import { useState } from 'react';

interface SortOption {
  value: string;
  label: string;
}

interface NewsFilterProps {
  categories: string[];
  category: string;
  onCategory: (value: string) => void;
  sort: string;
  onSort: (value: string) => void;
  sortOptions: SortOption[];
  total: number;
  unit?: string;
}

export default function NewsFilter({
  categories,
  category,
  onCategory,
  sort,
  onSort,
  sortOptions,
  total,
  unit = '条内容',
}: NewsFilterProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const chipClass = (active: boolean) =>
    `whitespace-nowrap rounded-full px-3.5 py-1.5 text-sm font-medium transition-colors cursor-pointer ${
      active
        ? 'bg-primary-500 text-background-50 dark:text-foreground-950'
        : 'bg-background-50 text-foreground-600 hover:bg-background-200'
    }`;

  return (
    <div className="rounded-lg border border-background-200 bg-background-50">
      <div className="flex items-center justify-between gap-3 border-b border-background-200 px-4 py-3 md:hidden">
        <div className="flex items-center gap-2 text-sm text-foreground-600">
          <i className="ri-filter-3-line text-primary-600"></i>
          共 <span className="font-semibold text-foreground-900">{total}</span> {unit}
        </div>
        <button
          type="button"
          onClick={() => setMobileOpen((v) => !v)}
          className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-1.5 text-sm font-medium text-foreground-700"
        >
          <i className={mobileOpen ? 'ri-close-line' : 'ri-equalizer-line'}></i>
          筛选 / 排序
        </button>
      </div>

      <div className={`${mobileOpen ? 'block' : 'hidden'} px-4 py-4 md:block md:px-5`}>
        <div className="flex flex-col gap-4 md:flex-row md:items-center md:justify-between">
          <div className="flex flex-wrap items-center gap-2">
            <span className="hidden text-sm text-foreground-500 md:inline">分类：</span>
            {categories.map((item) => (
              <button
                key={item}
                type="button"
                onClick={() => onCategory(item)}
                className={chipClass(item === category)}
              >
                {item}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <span className="text-sm text-foreground-500">排序：</span>
            <select
              value={sort}
              onChange={(e) => onSort(e.target.value)}
              className="cursor-pointer rounded-md border border-background-300 bg-background-50 px-3 py-1.5 text-sm text-foreground-800 outline-none transition-colors focus:border-primary-400"
            >
              {sortOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    </div>
  );
}